<template>
	<div class="phone-page">
		<div class="detail">
			<div class="wrapper">
				<div class="detail-title">
					<img class="detail-img" :src="ruleForm.contentImgUrl">
					<div class="info">
						<div class="left">
							<span>{{ ruleForm.title }}</span>
							<span>{{ currentTime() }}</span>
						</div>
						<div class="right">
							<img class="look" src="@/assets/img/eye.png">
							<span>浏览：1456</span>
						</div>
					</div>
				</div>
				<div class="date" v-if="sourceType === 3">
					<div class="status">进行中</div>
					<div class="date-detail">
						<span class="sign-up-time">报名时间 {{ ruleForm.signUpTime[0] | dateFormat }} 至 {{ ruleForm.signUpTime[1] | dateFormat }}</span>
						<span class="run-time">活动时间 {{ ruleForm.beginTime[0] | dateFormat }} 至 {{ ruleForm.beginTime[1] | dateFormat }}</span>
					</div>
				</div>
				<div class="article" v-if="sourceType === 2&&ruleForm.articleAbstract">{{ ruleForm.articleAbstract }}</div>
				<div class="content">
					<div class="name">公告内容</div>
					<div class="content-detail" v-html="ruleForm.bannerContent"></div>
				</div>
			</div>
			<div class="sign-up">
				<button type="default" class="btn">我要报名</button>
			</div>
			<div class="close" @click="$emit('closePrview')">
					<i class="el-icon-close" style="font-size: 40px;"></i>
				</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

export default {
  props: {
    ruleForm: {
      type: Object,
      default: () => {
        return {}
      }
    },
    sourceType: {
      type: Number,
      default: 1
    }
  },
  filters: {
    dateFormat (date) {
      return moment(date).format('MM/DD HH:mm')
    }
  },
  methods: {
    currentTime () {
      return moment().format('MM/DD HH:mm')
    }
  }
}
</script>

<style lang="scss">
	.content-detail {
		white-space:pre-wrap;
		video {
			width: 100%;
		}
		img {
			width: 100%;
		}
	}
</style>
<style lang="scss" scoped>
	.phone-page {
		position: fixed;
		z-index: 99;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		background-color: rgba(0, 0, 0, 0.4);
	}
	.detail {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translate(-50%, -50%) scale(0.6);
    width: 750px;
    height: 1334px;
		background-color: #EFEFF4;
		border: 1px solid #EFEFF4;
		display: flex;
		flex-direction: column;
		.wrapper {
			position: relative;
			height: 0;
			flex-grow: 1;
			overflow-y: scroll;	
			&::-webkit-scrollbar {
				width: 0;
			}
			.detail-title {
				width: 100%;
				// height: 385px;
				background-color: #fff;
				.detail-img {
					width: 100%;
					// height: 280px;
				}
				.info {
					padding: 20px;
					height: 105px;
					display: flex;
					align-items: center;
					.left {
						width: 70%;
						height: 100%;
						display: flex;
						flex-direction: column;
						justify-content: space-between;
						span {
							font-family: PingFang SC;
							font-size: 26px;
							color: #464C5E;
							&:nth-child(2) {
								font-size: 24px;
								color: #999999;
							}
						}
					}
					.right {
						width: 30%;
						display: flex;
						align-items: center;
						justify-content: flex-end;
						.look {
							width: 23px;
							height: 17px;
							margin-right: 16px;
						}
						span {
							font-family: PingFang SC;
							font-size: 20px;
							color: #464C5E;
						}
					}
				}
			}
			.article {
				background-color: #fff;
				font-size: 24px;
				color: #464C5E;
				padding: 20px;
				margin-top: 20px;
			}
			.date {
				height: 125px;
				background-color: #fff;
				margin-top: 20px;
				padding: 25px 20px;
				display: flex;
				align-items: center;
				.status {
					width: 108px;
					height: 48px;
					background: #00AF84;
					font-family: PingFang SC;
					font-size: 24px;
					color: #FFFFFF;
					display: flex;
					align-items: center;
					justify-content: center;
					margin-right: 50px;
				}
				.date-detail {
					height: 100%;
					display: flex;
					flex-direction: column;
					justify-content: space-between;
					.sign-up-time, .run-time {
						font-family: PingFang SC;
						font-size: 24px;
						color: #464C5E;
						word-break: break-all;
						word-wrap: break-word;
					}
				}
			}
			.content {
				margin-top: 20px;
				flex-grow: 1;
				background-color: #fff;
				padding: 0 20px;
				.name {
					height: 64px;
					background-color: #fff;
					font-family: PingFang SC;
					font-weight: 600;
					font-size: 26px;
					color: #464C5E;
					display: flex;
					align-items: center;
				}
			}
		}
		.sign-up {
			background-color: #fff;
			width: 100%;
			height: 140px;
			display: flex;
			align-items: center;
			justify-content: center;
			.btn {
				width: 702px;
				height: 80px;
				background: linear-gradient(-90deg, #00AF84, #D9F65C);
				box-shadow: 0rpx 8rpx 28rpx 2rpx rgba(41,157,128,0.35);
				border-radius: 40px;
				border: none;
				font-family: PingFang SC;
				font-weight: bold;
				font-size: 30px;
				color: #FFFFFF;
			}
		}
		.close{
				position: absolute;
				right:10px;
				width: 30px;
				height:30px;
				cursor: pointer;
			}
	}
</style>